import { render, staticRenderFns } from "./streamPlayer.vue?vue&type=template&id=1c82be2a&scoped=true"
import script from "./streamPlayer.vue?vue&type=script&lang=js"
export * from "./streamPlayer.vue?vue&type=script&lang=js"
import style0 from "./streamPlayer.vue?vue&type=style&index=0&id=1c82be2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c82be2a",
  null
  
)

export default component.exports